import { getCurrentLanguage } from '../../translations.js';

let dismissClick = null;
let dismissKeydown = null;

const clearDismissListeners = () => {
  if (dismissClick) document.removeEventListener('click', dismissClick);
  if (dismissKeydown) document.removeEventListener('keydown', dismissKeydown);
  dismissClick = null;
  dismissKeydown = null;
};

const removePanelHelpTooltip = () => {
  document.querySelector('.description-tooltip')?.remove();
  clearDismissListeners();
};

const resolveHelpText = (key) => {
  const lang = getCurrentLanguage() || 'en';
  return window.translations?.[lang]?.['create-character']?.[key]
    ?? window.translations?.en?.['create-character']?.[key]
    ?? '';
};

const positionPanelHelpTooltip = (tooltip, iconElement) => {
  if (!iconElement) return;
  const iconRect = iconElement.getBoundingClientRect();
  const tooltipWidth = tooltip.getBoundingClientRect().width;
  const spaceOnLeft = iconRect.left;
  const spaceOnRight = window.innerWidth - iconRect.right;

  if (spaceOnLeft >= tooltipWidth + 10) {
    tooltip.style.right = `${window.innerWidth - iconRect.left + 10}px`;
    tooltip.style.top = `${iconRect.top}px`;
    return;
  }
  if (spaceOnRight >= tooltipWidth + 10) {
    tooltip.style.left = `${iconRect.right + 10}px`;
    tooltip.style.top = `${iconRect.top}px`;
    return;
  }
  tooltip.style.left = '30%';
  tooltip.style.top = `${iconRect.bottom + 10}px`;
  tooltip.style.transform = 'translateX(-20%)';
};

const attachPanelHelpTooltipDismiss = (tooltip) => {
  clearDismissListeners();
  dismissClick = (event) => {
    if (event?.target instanceof Element) {
      if (tooltip.contains(event.target) || event.target.closest('.panel-title-info')) return;
    }
    removePanelHelpTooltip();
  };
  dismissKeydown = (event) => {
    if (event.key !== 'Escape') return;
    removePanelHelpTooltip();
  };
  setTimeout(() => {
    if (!dismissClick || !dismissKeydown) return;
    document.addEventListener('click', dismissClick);
    document.addEventListener('keydown', dismissKeydown);
  }, 100);
};

const showPanelHelpTooltip = (iconElement, text) => {
  removePanelHelpTooltip();
  if (!text) return;
  const tooltip = document.createElement('div');
  tooltip.className = 'description-tooltip';
  const description = document.createElement('p');
  description.className = 'description-tooltip-text';
  description.textContent = text;
  tooltip.appendChild(description);
  tooltip.addEventListener('click', (event) => event.stopPropagation());
  document.body.appendChild(tooltip);
  positionPanelHelpTooltip(tooltip, iconElement);
  requestAnimationFrame(() => tooltip.classList.add('is-visible'));
  attachPanelHelpTooltipDismiss(tooltip);
};

const handlePanelHelpOpen = (event) => {
  event.preventDefault();
  event.stopPropagation();
  const button = event.currentTarget;
  if (!(button instanceof HTMLElement)) return;
  const key = button.dataset.helpKey;
  if (!key) return;
  showPanelHelpTooltip(button, resolveHelpText(key));
};

const handlePanelHelpKeydown = (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  handlePanelHelpOpen(event);
};

export const bindPanelHelpTooltips = () => {
  document.querySelectorAll('.panel-title-info').forEach((button) => {
    button.addEventListener('click', handlePanelHelpOpen);
    button.addEventListener('keydown', handlePanelHelpKeydown);
  });
};
